 // Gravity Forms
 jQuery(document).ready(function($){
    $(document).on("gform_confirmation_loaded", function (e, form_id) {
        $('#section-contact-form').hide();
        $('#section-contact-success').show();
        myFullpage.silentMoveTo('benefits'); 
        myFullpage.moveTo('contact'); 
    });

    $(document).on("click", ".go-to-contact", function (e) {
        e.preventDefault();
        myFullpage.silentMoveTo('benefits'); 
        myFullpage.moveTo('contact'); 
    });
});